/*
 * APOLLO'S VISITOR TRACKER on the public booking page (asked for 2026-10-21):
 * names the company behind a visit, read back in Apollo. Loaded from here, not
 * index.html, because that one file is also the whole CRM, and the CRM is not
 * a page anyone should be tracked on. The same app id as remotion.io and the
 * landing pages (src/landing/render.js).
 *
 * Not inside a landing page's frame (the page around it already counted the
 * visit) and not in the CRM's preview (that visitor is Remotion).
 */
import { embedded } from "./embed";

const APP_ID = "6633487e23c61406b26ac504";
let loaded = false;

export function loadApollo({ preview } = {}) {
  if (loaded || embedded || preview || typeof document === "undefined") return;
  loaded = true;
  const s = document.createElement("script");
  s.src = `https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache=${Math.random().toString(36).substring(7)}`;
  s.async = true;
  s.defer = true;
  s.onload = () => {
    try {
      window.trackingFunctions.onLoad({ appId: APP_ID });
    } catch (err) {
      // A tracker that fails to start costs a visit count, never the booking.
    }
  };
  document.head.appendChild(s);
}
